import { LibraryTagTreeItem } from 'types';

export const flattenTagTree = (
  nodes: LibraryTagTreeItem[]
): LibraryTagTreeItem[] => {
  const result: LibraryTagTreeItem[] = [];

  const walk = (items: LibraryTagTreeItem[]) => {
    for (const item of items) {
      result.push(item);
      if (item.children?.length) walk(item.children);
    }
  };

  walk(nodes);
  return result;
};

export const filterTree = (
  treeItems: LibraryTagTreeItem[],
  query: string
): {
  matchCount: number;
  expandIds: Set<string>;
  filtered: LibraryTagTreeItem[];
} => {
  const lower = query.trim().toLowerCase();

  if (!lower) {
    return { matchCount: 0, filtered: treeItems, expandIds: new Set<string>() };
  }

  const expandIds = new Set<string>();
  let matchCount = 0;

  const walk = (node: LibraryTagTreeItem): LibraryTagTreeItem | null => {
    const childMatches = (node.children || [])
      .map(walk)
      .filter((child): child is LibraryTagTreeItem => child !== null);
    const isSelfMatch = node.name.toLowerCase().includes(lower);

    if (!isSelfMatch && !childMatches.length) {
      return null;
    }

    if (isSelfMatch) matchCount++;

    if (childMatches.length) {
      expandIds.add(node.id);
    }

    return {
      ...node,
      children: childMatches,
    };
  };

  const filtered = treeItems
    .map(walk)
    .filter((item): item is LibraryTagTreeItem => item !== null);

  return { filtered, expandIds, matchCount };
};
